import React from "react";
import useStyles from "./styles";
import Typography from "@components/Typography";
import { Grid } from "@material-ui/core";

export default function Empty({ note, size, noteComponent }) {
  const classes = useStyles();
  const theme = window.localStorage.getItem("theme");
  return (
    <div className={size === "small" ? classes.smallRoot : classes.root}>
      <Grid container direction="column" justify="center" alignItems="center">
        <img
          src={
            theme === "DARK"
              ? "/static/icons/Illustration/EmptyInboxSVG.svg"
              : "/static/icons/Illustration/EmptyInbox-bg graySVG.svg"
          }
          alt="empty"
        />
        {!!noteComponent ? (
          noteComponent
        ) : (
          <Typography variant="xs" color="secondary.tint40">
            {note}
          </Typography>
        )}
      </Grid>
    </div>
  );
}
